export const ANGORA_ENV = process.env.ANGORA_ENV;

export const HOSTNAME = process.env.HOSTNAME;

export const ANGORA_KEY = process.env.ANGORA_KEY;

export const GITHUB_SHA = process.env.GITHUB_SHA;

export const NODE_ENV = process.env.NODE_ENV;
